export const TITLE_MAX_LENGTH = 50;
export const DESCRIPTION_MAX_LENGTH = 300;
export const SALES_TARGET_SIMPLE_IMAGE_TYPES = [
  'image/webp',
  'image/jpeg',
  'image/png'
];
export const SALES_TARGET_SIMPLE_IMAGE_MAX_SIZE_BYTES = 70 * 1024;

export const STRING_SCHEMA = {type: 'string'};

const REQUIRED_RULE = {type: 'required', msg: ' is required'};
const maxLengthRule = (limit) => ({
  type: 'maxLength',
  limit,
  msg: ` must be less than or equal to ${limit} characters`
});

export const salesTargetSimpleTitleUiSchema = {
  label: 'Title*',
  placeholder: 'Title',
  isDark: true,
  tooltipText: `Limit: ${TITLE_MAX_LENGTH} characters, 2 lines maximum. Spaces are counted`,
  validationRules: [REQUIRED_RULE, maxLengthRule(TITLE_MAX_LENGTH)]
};

export const salesTargetSimpleDescriptionUiSchema = {
  label: 'Description*',
  placeholder: 'Description',
  isDark: true,
  showToolbar: false,
  rows: 5,
  maxLength: DESCRIPTION_MAX_LENGTH,
  tooltipText: `Limit ${DESCRIPTION_MAX_LENGTH} characters`,
  validationRules: [REQUIRED_RULE, maxLengthRule(DESCRIPTION_MAX_LENGTH)]
};

export const SALES_TARGET_SIMPLE_DISPLAY_FIELDS = [
  {key: 'title', type: 'input', uiSchema: salesTargetSimpleTitleUiSchema},
  {
    key: 'description',
    type: 'textarea',
    uiSchema: salesTargetSimpleDescriptionUiSchema
  }
];

export const buildTargetImageDescription = (dimensions, maxSizeBytes) =>
  `Required: WebP, JPG, PNG \u2022 ${dimensions.width} \u00d7 ${dimensions.height} px RGB \u2022 Max. ${maxSizeBytes / 1024} KB`;

export const hasSalesTargetSimpleDisplayFormError = ({
  targetImage,
  languages,
  displayContent
}) => {
  if (!targetImage) return true;

  for (const lang of languages) {
    const content = displayContent?.[lang.code];
    if (!content?.title || content?.title.trim() === '') return true;
    if (content?.titleValid === true) return true;
    if (!content?.description || content?.description.trim() === '')
      return true;
    if (content?.descriptionValid === true) return true;
  }
  return false;
};

export const buildSalesTargetSimpleDisplayContentFormData = ({
  languages,
  displayContent,
  targetType
}) => {
  const formData = {};
  languages.forEach((lang) => {
    const data = displayContent?.[lang.code] || {};
    formData[lang.code] = {
      targetType,
      title: data.title || '',
      description: data.description || ''
    };
  });
  return formData;
};
